import { render, staticRenderFns } from "./PlatformAdvertStairSwiper.vue?vue&type=template&id=77b249f7&scoped=true&"
import script from "./PlatformAdvertStairSwiper.vue?vue&type=script&lang=js&"
export * from "./PlatformAdvertStairSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b249f7",
  null
  
)

export default component.exports